import React from 'react'
import { useTranslation } from 'react-i18next'
import { PortfolioCard } from './PortfolioCard'

type PortfolioWidgetView = {
    key: string
    label: string
    color: string
    insufficientSample: boolean
    value: string
    widthPct: number
    note: string
    markets: Array<{ code: string; widthPct: number; value: string }>
}

type PortfolioHealthSectionProps = {
    widgets: PortfolioWidgetView[]
}

export const PortfolioHealthSection: React.FC<PortfolioHealthSectionProps> = ({ widgets }) => {
    const { t } = useTranslation('dashboard')
    return (
    <section className="flex flex-col gap-3">
        <div className="flex items-baseline gap-2.5 flex-wrap">
            <h2 className="text-[17px] font-semibold tracking-tight text-neutralBlack-900">{t('metrics.portfolioHealthTitle')}</h2>
            <span className="text-[13px] text-neutralBlack-600">{t('metrics.portfolioHealthSubtitle')}</span>
        </div>

        <div className="grid gap-3" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(258px, 1fr))' }}>
            {widgets.map((widget) => (
                <PortfolioCard
                    key={widget.key}
                    label={widget.label}
                    value={widget.value}
                    widthPct={widget.widthPct}
                    color={widget.color}
                    note={widget.note}
                    insufficientSample={widget.insufficientSample}
                    markets={widget.markets}
                />
            ))}
        </div>
    </section>
    )
}
